module.exports = __webpack_public_path__ + "assets/cupon-0eb248.svg";